export const removeHistoryState = (history, stateProp) => {
  if (history && history.location && history.location.state && history.location.state[stateProp]) {
    let state = { ...history.location.state };
    delete state[stateProp];
    history.replace({ ...history.location, state });
  }
};
